module.exports = __webpack_public_path__ + "img/COREPRODUCTS.b9b2f09d.png";